var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6693 8.66406V9.9974C14.6693 13.3307 13.3359 14.6641 10.0026 14.6641H6.0026C2.66927 14.6641 1.33594 13.3307 1.33594 9.9974V8.98406",
    stroke: "#E86025",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33594 1.33594H6.0026C2.66927 1.33594 1.33594 2.66927 1.33594 6.0026",
    stroke: "#E86025",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2905 6.00488L13.9905 5.30488C14.8972 4.39822 15.3238 3.34488 13.9905 2.01155C12.6572 0.678215 11.6038 1.10488 10.6972 2.01155L5.44383 7.26488C5.24383 7.46488 5.04383 7.85822 5.00383 8.14488L4.71716 10.1515C4.61049 10.8782 5.12383 11.3849 5.85049 11.2849L7.85716 10.9982C8.13716 10.9582 8.53049 10.7582 8.73716 10.5582L10.8572 8.43822L11.3438 7.95155",
    stroke: "#E86025",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 2.76562C10.3842 4.35896 11.6308 5.60562 13.2308 6.05896",
    stroke: "#E86025",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconOrange);
export default __webpack_public_path__ + "static/media/edit-icon-orange.157c20a4e268f94f098e2aa1ea4b5e7a.svg";
export { ForwardRef as ReactComponent };